import { c as _c } from "react/compiler-runtime";
import { LazyImage } from "@website/ui/lazy-image";
import { useListItem } from "@website/ui/list-item/list-item.hook";
import styles from "@website/ui/list-item/list-item.module.scss";
import { ListItemPropertiesType } from "@website/ui/list-item/list-item.types";
import { FC } from "react";
export const ListItem: FC<ListItemPropertiesType> = properties => {
  const $ = _c(44);
  const {
    className,
    EndAction,
    EndIcon,
    image,
    Meta,
    overline,
    role,
    size: t0,
    subtitle,
    StartAction,
    StartIcon,
    title,
    isCollapsed,
    disabled,
    titleClassName,
    subtitleClassName,
    "aria-disabled": ariaDisabled
  } = properties;
  const size = t0 === undefined ? "medium" : t0;
  const {
    rootProps
  } = useListItem(properties);
  let t1;
  if ($[0] !== image || $[1] !== title) {
    t1 = image && <div className="flex-[0_0_64px]"><LazyImage alt={typeof title === "string" ? title : ""} src={image} /></div>;
    $[0] = image;
    $[1] = title;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== StartAction) {
    t2 = StartAction && <div className={styles["start-action"]}>{StartAction}</div>;
    $[3] = StartAction;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== StartIcon) {
    t3 = StartIcon && <div className={styles.icon}>{StartIcon}</div>;
    $[5] = StartIcon;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const t4 = `flex-1 whitespace-nowrap transition-opacity duration-300 ${isCollapsed ? "opacity-0" : "opacity-100 delay-200"}`;
  let t5;
  if ($[7] !== overline) {
    t5 = overline && <div className={styles.overline}>{overline}</div>;
    $[7] = overline;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== ariaDisabled || $[10] !== disabled || $[11] !== title || $[12] !== titleClassName) {
    t6 = title && <div className={`${styles.title} ${disabled || ariaDisabled ? styles.disabled : ""} ${titleClassName ?? ""}`}>{title}</div>;
    $[9] = ariaDisabled;
    $[10] = disabled;
    $[11] = title;
    $[12] = titleClassName;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== ariaDisabled || $[15] !== disabled || $[16] !== subtitle || $[17] !== subtitleClassName) {
    t7 = subtitle && <div className={`${styles.subtitle} ${disabled || ariaDisabled ? styles.disabled : ""} ${subtitleClassName ?? ""}`}>{subtitle}</div>;
    $[14] = ariaDisabled;
    $[15] = disabled;
    $[16] = subtitle;
    $[17] = subtitleClassName;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t4 || $[20] !== t5 || $[21] !== t6 || $[22] !== t7) {
    t8 = <div className={t4}>{t5}{t6}{t7}</div>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== Meta) {
    t9 = Meta && <div className={styles.meta}>{Meta}</div>;
    $[24] = Meta;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== EndIcon) {
    t10 = EndIcon && <div className={styles.icon}>{EndIcon}</div>;
    $[26] = EndIcon;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== EndAction) {
    t11 = EndAction && <div className={styles["end-action"]}>{EndAction}</div>;
    $[28] = EndAction;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  let t12;
  if ($[30] !== t1 || $[31] !== t10 || $[32] !== t11 || $[33] !== t2 || $[34] !== t3 || $[35] !== t8 || $[36] !== t9) {
    t12 = <>{t1}{t2}{t3}{t8}{t9}{t10}{t11}</>;
    $[30] = t1;
    $[31] = t10;
    $[32] = t11;
    $[33] = t2;
    $[34] = t3;
    $[35] = t8;
    $[36] = t9;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  const inside = t12;
  const Tag = role === "link" ? "a" : role === "button" ? "button" : "div";
  const roleProperties = role === "link" ? rootProps.link : role === "button" ? rootProps.button : rootProps.default;
  const t13 = `${styles["list-item"]} ${styles[size]} ${className ?? ""} ${isCollapsed && image ? "px-2" : "px-6"}`;
  let t14;
  if ($[38] !== Tag || $[39] !== ariaDisabled || $[40] !== inside || $[41] !== roleProperties || $[42] !== t13) {
    t14 = <Tag aria-disabled={ariaDisabled} {...roleProperties} className={t13}>{inside}</Tag>;
    $[38] = Tag;
    $[39] = ariaDisabled;
    $[40] = inside;
    $[41] = roleProperties;
    $[42] = t13;
    $[43] = t14;
  } else {
    t14 = $[43];
  }
  return t14;
};